import type { ReactNode } from "react";

import {
  ClientAreaIcon,
  ClientsIcon,
  ContractIcon,
  HomeIcon,
  OrganizationIcon,
  SubscriptionIcon,
} from "../components/icons";

/**
 * Gezinme öğesi → ikon eşlemesi.
 *
 * ### Neden `navigation.ts`'te değil
 *
 * O kayıt saf veri (`.ts`) ve sunucudan gelen yetkilerle birlikte test ediliyor; içine
 * JSX koymak, görünürlük kuralının testini bir render testine çevirirdi. İkon bir SUNUM
 * ayrıntısı — kaydın kendisi ikonsuz da anlamlı.
 *
 * ### Eksik anahtar ÇÖKMEZ
 *
 * Kayıt yeni bir öğe kazandığında burada karşılığı olmayabilir; o durumda öğe ikonsuz
 * çizilir. Eşleme zorunlu olsaydı, kartıyla gelen yeni bir domain ikon eklenene kadar
 * gezinmeyi düşürürdü.
 */
const IKONLAR: Record<string, ReactNode> = {
  home: <HomeIcon />,
  contracts: <ContractIcon />,
  clients: <ClientsIcon />,
  "client-portal": <ClientAreaIcon />,
  "client-workspace": <ClientAreaIcon />,
  organization: <OrganizationIcon />,
  subscription: <SubscriptionIcon />,
};

export function navIcon(key: string): ReactNode {
  return IKONLAR[key] ?? null;
}
